// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "passenger-Dg-uu";
var _3 = "active-mYXtM";
var _4 = "label-28Cmo";
var _5 = "checkbox-2VXwC";
export { _1 as "__esModule", _2 as "passenger", _3 as "active", _4 as "label", _5 as "checkbox" }
export default { "__esModule": _1, "passenger": _2, "active": _3, "label": _4, "checkbox": _5 }
